import { svg } from "config/svgStyles";

export const cardButton =
  ({ backgroundColor, backgroundImage, color }) =>
  () => ({
    backgroundImage,
    backgroundColor,
    color,
    margin: "0",
    padding: "0",
    display: "flex",
    flexDirection: "column",
    border: "none",
    borderRadius: "0 0 8px 8px",
    fontFamily: "body",
    width: "100%",
    flexGrow: 1,
    flexShrink: 1,
    textDecoration: "none",
    cursor: "pointer",

    "&:disabled": {
      cursor: "not-allowed",
    },

    "&:focus": {
      outline: `solid 2px ${backgroundColor}`,
      outlineOffset: "2px",
    },
  });

export const labelBox = ({ isMobile }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  flexGrow: 1,
  flexShrink: 1,
  width: "100%",
  padding: isMobile ? "20px" : "30px",
  minHeight: isMobile ? "124px" : "180px",
});

export const description = {
  marginBottom: "20px",
  lineHeight: "1",
};

export const floatingLabel = ({ styles }) => ({
  height: "40px",
  padding: "10px",
  position: "absolute",
  top: "-10px",
  left: "-10px",
  fontSize: "20px",
  lineHeight: "20px",
  letterSpacing: "0.05em",
  whiteSpace: "nowrap",
  borderRadius: "10px",
  ...styles,
});

export const logosContainer = {
  height: "50px",
  display: "flex",
  flexDirection: "column",
  // justifyContent: "center",
  gap: "12px",
};

export const logo = {
  display: "flex",
  maxWidth: "180px",
  maxHeight: "40px",
  margin: "auto 0",
  fill: "#fff",
  filter: "drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.25))",
  width: "100%",
};

export const productLogo = {
  display: "flex",
  margin: "auto 0",
  fill: "#fff",
  filter: "drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.25))",
  width: "100%",
  justifyContent: "center",
};

export const productLogoOverlay = {
  width: "100%",
  height: "100%",
  position: "absolute",
  top: "0",
};

export const subText = {
  fontSize: "14px",
  letterSpacing: "0.05em",
  lineHeight: "18px",
  marginTop: "20px",
};

export const selectLabel = {
  marginTop: "32px",
  padding: "10px 20px 10px 30px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "20px",
  borderRadius: "20px",
  background: "white",
  color: "black",
};

export const selectLabelIcon = () => ({
  width: "16px",
  height: "16px",
  ...svg("black"),
});

export const ProductButtonWithImage = {
  transition: "transform .2s",
  "&:hover": {
    transform: "scale(1.04)",
  },
  "&:focus": {
    transform: "scale(1.04)",
  },
};

export const productImage = {
  width: "100%",
  display: "flex",
  borderRadius: "8px 8px 0 0",
};
